import { connect } from 'react-redux';
import { getFocusMatchId } from '../reducers/config';
import FocusMatchPresentation from '../presentations/FocusMatch/FocusMatchPresentation';
import { getFocusMatchStatus, getLayout } from '../reducers/focusMatch';
import { IState } from '../store/state';

const mapStateToProps = (state: IState) => {
  return ({
      focusmatchid: getFocusMatchId( state ),
      focusMatchStatus: getFocusMatchStatus( state ),
      layout: getLayout( state )
  })
};

export default connect( mapStateToProps, {} )( FocusMatchPresentation );
